import ApiConstants from "../../constants/ApiConstant";
import { apiGet } from "../../services/apiService";

export const getJobListAPI = (data, callBack) => {
    return async () => {
        try {
            await apiGet(ApiConstants.jobListUrl, data)
                .then((response) => {
                    callBack && callBack(response?.data, response?.data);
                })
                .catch((err) => {
                    console.error("get job list api err===-=>>>:", err);
                    throw err;
                });
        } catch (err) {
            console.error("get job list api err:", err);
            throw err;
        }
    };
};